"use client";

import { useTranslation } from "@/lib/hooks/use-translation";

/**
 * Re-opens the cookie preferences modal. Lets visitors change or withdraw
 * consent at any time (a PDPA/GDPR requirement), styled to match the other
 * footer bottom-bar links.
 *
 * The library is pulled in inside the click handler rather than imported at
 * module scope: this button lives in the footer, which every page loads
 * eagerly, so a static import put all ~26 KB of vanilla-cookieconsent in the
 * initial bundle and undid the lazy load in `cookie-consent-loader`. By the
 * time anyone reaches the footer the loader has already `run()` the manager,
 * and `import()` resolves to that same module instance, so the modal opens
 * with the visitor's current consent state.
 */
export default function ManageCookiesButton() {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={async () => {
        const CookieConsent = await import("vanilla-cookieconsent");
        CookieConsent.showPreferences();
      }}
      className="text-sm font-normal leading-5 text-white transition-colors hover:text-white/70"
    >
      {t("footer.manageCookies")}
    </button>
  );
}
